import axios from "axios";
import { IndustryMstModel } from "models";
import { IAPIResult } from "models/interfaces";

export async function entryList(token: string) {
  // await Utils.sleep(300);

  const response = await axios.get<IAPIResult<IndustryMstModel[]>>(
    "/api.d/v1/entry/industry-mst/list",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function list() {
  // await Utils.sleep(300);

  const response = await axios.get<IAPIResult<IndustryMstModel[]>>(
    "/api.d/v1/ec/industry-mst/list"
  );
  return response.data;
}
